export const regionalInsights = {
  'Algeria': {
    theme: 'Breathing life into education with extracurricular activities',
    currentChallenges: 'Overwhelmingly dense curriculum, overcrowded classrooms, lack of extracurricular activities',
    preferredFuture: 'Practical hands-on learning, modular adaptive classrooms, afternoon hobby exploration, alumni mentorship',
    scanHit: 'VR simulations for immersive learning experiences'
  },
  'Ecuador': {
    theme: 'Youth assemblies cultivating empathy and well-being in schools', 
    currentChallenges: 'Gaps in emotional and mental health support, academic performance prioritized over well-being',
    preferredFuture: 'Emotional well-being as core curriculum, peace education, youth-centered decision making',
    scanHit: 'Emotional intelligence as core competency in all schools'
  },
  'France': {
    theme: 'Bridging the gap between policies and realities for gender inclusivity',
    currentChallenges: 'Disconnect between inclusive policies and lived experiences, inconsistent implementation',
    preferredFuture: 'Gender-neutral environments, intersectional education, student choice in learning participation',
    scanHit: 'Policy implementation tracking and youth involvement in monitoring'
  },
  'Ghana': {
    theme: 'AI-powered learning hubs uniting students and teachers',
    currentChallenges: 'Mismatch in AI perceptions between teachers and students, traditional teaching methods',
    preferredFuture: 'AI as foundational skill, thinking hubs for collaboration, human-AI partnership',
    scanHit: 'AI replacing traditional teaching methods in some contexts'
  },
  'Guinea-Bissau': {
    theme: 'Changing education to keep pace with the changing climate',
    currentChallenges: 'Climate change impacts on school access, inadequate infrastructure for environmental challenges',
    preferredFuture: 'Personal digital devices for all students, eco-literacy curriculum, climate-resilient infrastructure',
    scanHit: 'Climate migration creating education refugees'
  },
  'Haiti': {
    theme: 'Mobile-based learning reaching curious minds during conflict',
    currentChallenges: 'Education disrupted by security threats, students burdened with adult responsibilities',
    preferredFuture: 'Peace and safety enabling accessible education, community-based learning solutions',
    scanHit: 'Solar-powered digital learning tools for conflict-affected areas'
  },
  'India': {
    theme: 'Girls reclaiming their right to move and think freely',
    currentChallenges: 'Gender-based inequalities in education access, restrictive school culture for girls',
    preferredFuture: 'Free varied-style uniforms, safe spaces for girls, gender-neutral feedback and activities',
    scanHit: 'Flexible learning arrangements helping overcome traditional barriers'
  },
  'Kazakhstan': {
    theme: 'Different and together, inclusive education celebrating all abilities',
    currentChallenges: 'Reliance on special schools, limited TVET diversity for students with disabilities',
    preferredFuture: 'Inclusive mainstream environments, teachers with disabilities as role models, empathy-building curricula',
    scanHit: 'Individualized Education Plans and adaptive learning platforms'
  },
  'Kenya': {
    theme: 'Teaching AI literacy as a foundational skill to thrive',
    currentChallenges: 'Breadth over depth education, students unprepared for AI-integrated world',
    preferredFuture: 'Emotional intelligence and adaptability focus, AI collaboration skills, meta-learning capabilities',
    scanHit: 'Students designing AI systems to explore ethical dilemmas'
  },
  'Madagascar': {
    theme: 'Preparing for life beyond school through Fihavanana and Farimbona',
    currentChallenges: 'Education system not preparing students for real world, limited job opportunities',
    preferredFuture: 'Early career orientation, practice-based learning, Malagasy values of solidarity and mutual aid',
    scanHit: 'Gamified career exploration allowing students to test drive professions'
  },
  'Mauritania': {
    theme: 'Families championing the right to education for girls',
    currentChallenges: 'Social norms and language barriers limiting girls education access',
    preferredFuture: 'Equal numbers of girls and boys in schools, families celebrating girls education',
    scanHit: 'AI translation technology eliminating language barriers in classrooms'
  },
  'Norway': {
    theme: 'From AI evaluators to AI mentors',
    currentChallenges: 'AI evaluation systems missing contextual factors, limiting student growth',
    preferredFuture: 'AI mentors understanding individual interests and learning preferences, transparent AI processing',
    scanHit: 'AI evaluation becoming primary method for assessing student achievements'
  },
  'Philippines': {
    theme: 'Climate education rooted in indigenous wisdom and community-based action',
    currentChallenges: 'Surface-level climate education, uneven access for marginalized communities',
    preferredFuture: 'Experimentation with climate solutions, indigenous knowledge integration, hands-on environmental projects',
    scanHit: 'Integration of indigenous storytelling and ecological practices into curricula'
  },
  'Senegal': {
    theme: 'Bringing girls back to school to safeguard their futures',
    currentChallenges: 'Sharp drop in girls secondary school enrollment, safety concerns and child marriage',
    preferredFuture: 'Gender parity in education, dedicated safeguarding teams, mental health support',
    scanHit: 'Rise in girls boarding schools and increased philanthropic support'
  },
  'United States of America': {
    theme: 'Diversify learning pathways for diverse needs',
    currentChallenges: 'Deep inequalities in higher education access, overemphasis on STEM fields',
    preferredFuture: 'Affordable and accessible higher education, transparent admissions, diverse pathways to success',
    scanHit: 'Direct-to-employer credentialing bypassing traditional degree requirements'
  }
};

export const regions = Object.keys(regionalInsights);
